import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';
import { Button } from 'react-bootstrap';
import { modalActions } from '../../../redux/modal';

const InciValidationButton = ({ onClick }) => (
  <Button bsSize="small" onClick={onClick}>
    <Translate value="product.inciValidation" />
  </Button>
);

const mapDispatchToProps = (dispatch, { productId }) => ({
  onClick: () => dispatch(modalActions.showEditInciListeModal({ productId })),
});

InciValidationButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(InciValidationButton);
